export const EVENTS = {
  event_airdrop: {
    name: "Airdrop",
    special: false,
  },
  event_cargoship: {
    name: "Cargo Ship",
    special: false,
  },
  event_cargoheli: {
    name: "Chinook",
    special: false,
  },
  event_helicopter: {
    name: "Patrol Helicopter",
    special: false,
  },
  event_halloween: {
    name: "Halloween",
    special: true,
  },
  event_xmas: {
    name: "Christmas",
    special: true,
  },
  event_easter: {
    name: "Easter",
    special: true,
  },
};
